// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"551":"57cb0e7c","1141":"45aae50b","2881":"5e540d1e","3192":"0640e871"}[chunkId] + ".chunk.css";
};